import { Box, Fade, Paper, Typography } from "@material-ui/core";
import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { Centered } from "@shoothill/core";
import { EditableCopyViewModel } from "Globals/ViewModels/EditableCopyViewModel";
import { useObserver } from "mobx-react-lite";

import "./ForgotPasswordSuccessView.scss";

export const ForgotPasswordSuccessView: React.FunctionComponent = () => {
    const [viewModel] = useState(() => new EditableCopyViewModel());

    const tickIcon = () => {
        return (
            <div className="tick-mark__container">
                <div className="tick-mark" />
            </div>
        );
    };

    return useObserver(() => (
        <div style={{ height: "100vh", width: "100vw", background: "gray", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Fade in timeout={1000}>
                <Paper>
                    <div className="success-message__container">
                        {tickIcon()}

                        <p style={{ fontSize: 25, fontWeight: "bold", marginBottom: 50 }}>Thank you!</p>
                        <p style={{ fontSize: 18 }}>A password reset link has been sent to your email account. </p>
                        <p style={{ fontSize: 18 }}>Please, check your inbox for an email from us.</p>
                        {/* <Typography component="h1" variant="h6" style={{ marginBottom: "25px", marginTop: "25px" }}>
                            {ReactHtmlParser(viewModel.getEditableCopyByRouteAndPlaceholderNumber("/forgotpassword-success", 1))}
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            {ReactHtmlParser(viewModel.getEditableCopyByRouteAndPlaceholderNumber("/forgotpassword-success", 2))}
                        </Typography> */}
                    </div>
                </Paper>
            </Fade>
        </div>
    ));
};
